import * as React from 'react';
import * as I18n from 'i18n-js';
import AlertBox from '@reverbdotcom/commons/dist/components/alert_box';

export default function CannotAddNewCardWarning() {

  return (
    <div className="mt-2">
      <AlertBox color="blue" small>
        {I18n.t('discovery.selectableCreditCardList.cannotAddNewCard')}
      </AlertBox>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/cannot_add_new_card_warning.tsx